<template>
  <div></div>
</template>

<script>
import Library from '@/library'

export default {
  name: 'QueryComponent',

  props: {
    query: {
      required: true
    }
  },

  mounted () {
    const query = this.query

    if (query && query.type) {
      this.$router.replace({
        name: `Search ${Library.Filters.toTitleCase(query.type)}`,
        params: { query: query.query }
      })
    } else {
      this.$router.replace({ name: 'Not Found' })
    }
  }
}
</script>
